import React, { useEffect, useState } from 'react';
import { isDefinedAndNotEmpty, isEmpty } from 'check-tool';
import { storage } from '../../firebase';
import Resizer from 'react-image-file-resizer';

import { 
	updateUserImage,
	updateUserDisplayName,
	updateUserEmail,
	updateUserFirstName,
	updateUserLastName,
	updateUserIsShow
} from 'backend/User';

import { getLastTimeAnswers } from 'backend/UserAnswer';

import Select from 'components/Select';

const UserInfo = ({user}) => {
  const [isEditDisplayName, setIsEditDisplayName] = useState('none');
  const [displayName, setDispalyName] = useState(user.displayName);
	const [isEditFirstName, setIsEditFirstName] = useState('none');
	const [firstName, setFirstName] = useState(user.nameFirst);
	const [isEditLastName, setIsEditLastName] = useState('none');
	const [lastName, setLastName] = useState(user.nameLast);
	const [isEditEmail, setIsEditEmail] = useState('none');
	const [email, setEmail] = useState(user.email);
	const [isEditIsShow, setIsEditIsShow] = useState('none');
	const [isShow, setIsShow] = useState(user.isShow);
	const [isEditImage, setIsEditImage] = useState(false);
	const [url, setUrl] = useState(user.photoURL);
	const [image, setImage] = useState(null);
  const [progress, setProgress] = useState(0);

	const [lastTimeAnswer, setLastTimeAnswer] = useState('-');
	const [totalSubcategoryAnswer, setTotalSubcategoryAnswer] = useState(0);
	const [totalQuestionAnswer, setTotalQuestionAnswer] = useState(0);

	useEffect(() => {
		getLastTimeAnswers(user.uid, 'all')
			.then((result) => {
				setLastTimeAnswer(result.lastTimeAnswer);
				setTotalQuestionAnswer(result.totalQuestions);
				setTotalSubcategoryAnswer(result.totalSubcategory);
			})
			.catch((error) => {
				console.log('error', error);
				setLastTimeAnswer('-');
			});
	}, []);

	const saveData = (field) => {
		if (field === 'displayName') {
			updateUserDisplayName(user.uid, displayName);
			setIsEditDisplayName('none');
		}
		if (field === 'email') {
			updateUserEmail(user.uid, email);
			setIsEditEmail('none');
		}
		if (field === 'firstName') {
			updateUserFirstName(user.uid, firstName);
			setIsEditFirstName('none');
		}
		if (field === 'lastName') {
			updateUserLastName(user.uid, lastName);
			setIsEditLastName('none');
		}
		if (field === 'isShow') {
			updateUserIsShow(user.uid, isShow);
			setIsEditIsShow('none');
		}
  };

  const handelChange = (event, field) => {
    if (field === 'displayName') {
      setDispalyName(event.target.value);
    }
		if (field === 'email') {
      setEmail(event.target.value);
    }
		if (field === 'firstName') {
      setFirstName(event.target.value);
    }
		if (field === 'lastName') {
      setLastName(event.target.value);
    }
		if (field === 'isShow') {
      setIsShow(event.target.value == 'true');
    }
  };

	const clickOnEditImage = () => {
		setIsEditImage(!isEditImage);
	};

	const handleChange = (e) => {
    if (e.target.files[0]) {
			try {
				Resizer.imageFileResizer(
					e.target.files[0],
					200,
					200,
					'PNG',
					100,
					0,
					uri => {
						setImage(uri);
					},
					'file',
					100,
					100,
				);
			} catch(err) {
				setImage(e.target.files[0]);
				console.log(err);
			}
    }
  };

	const handleUpload = (uid) => {
		if (!isEmpty(image)) {
			const uploadTask = storage.ref(`user/${uid}`).put(image);
			uploadTask.on(
				"state_changed",
				snapshot => {
					// progress function ...
					const progress = Math.round(
						(snapshot.bytesTransferred / snapshot.totalBytes) * 100
					);
					setProgress(progress);
				},
				error => {
					// Error function ...
					console.log(error);
				},
				() => {
					storage
						.ref("user")
						.child(uid)
						.getDownloadURL()
						.then((urlResult) => {
							updateUserImage(user.uid, urlResult);
							setUrl(urlResult);
							setIsEditImage(false);
						});
				}
			);
		}
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <h1>
          <b>{firstName} {lastName}</b>
          <small>({displayName})</small>
        </h1>
      </div>

      <div className="row">
        <div className="col-xs-12">
          <div>
						<div id="user-profile-1" className="user-profile row">
							<div className="col-xs-12 col-sm-3 center">
							  <div>
										<span className="profile-picture" style={{display: isEditImage ? 'none' : ''}}>
											{isDefinedAndNotEmpty(url) ? (
												<img 
													id="avatar" 
													className="editable img-responsive editable-click editable-empty" 
													alt={user.displayName +" Avatar"} 
													src={url}
													onClick={clickOnEditImage}
												/>
											) : (
												<button className="editable editable-click" onClick={clickOnEditImage} style={{border: 0}}>
													<i
														id="avatar"
														className="fa fa-user" 
														style={{color: '#CCCCCC', fontSize: 100}}
													/>	
												</button>
												
											)}
										</span>

										<div className="space-4"></div>

										<span className="editable-container editable-inline" style={{display: isEditImage ? '' : 'none'}}>
										<div>
											<progress value={progress} max="100" className="progress" />
											<br />
											<label className="ace-file-input">
												<input type="file" id="id-input-file-2" onChange={(e) => handleChange(e)} />
												<span className="ace-file-container" data-title="Choose">
													<span className="ace-file-name" data-title="No File ...">
														<i className=" ace-icon fa fa-upload"></i>
													</span>
												</span>
												<a className="remove" href="#">
													<i className=" ace-icon fa fa-times"></i>
												</a>
											</label>
											<button type="button" className="btn btn-sm btn-success" onClick={() => handleUpload(user.uid)}>
											  Загрузить
												<i className="ace-icon fa fa-upload icon-on-right bigger-110"></i>
											</button>
											<br />
											<br />
											{url ? ( <img src={url} alt="Uploaded Image" width="100" />) : null}
											</div>
										</span>
									</div>

									<div className="hr hr12 dotted"></div>

									<div className="clearfix">
										<div className="grid2">
											<span className="bigger-175 blue">{totalSubcategoryAnswer} / {totalQuestionAnswer}</span>

											<br />
											(подкатегорий / вопросов)
										</div>

										<div className="grid2">
											<span className="bigger-175 blue">{lastTimeAnswer}</span>

											<br />
											(последний раз отвечала)
										</div>
									</div>

									<div className="hr hr16 dotted"></div>
								</div>

							  <div className="col-xs-12 col-sm-9">
									<div className="profile-user-info profile-user-info-striped">
										<div className="profile-info-row">
											<div className="profile-info-name"> Логин </div>

											<div className="profile-info-value">
												<span
                          className="editable editable-click"
                          id="username" 
                          onClick={() => setIsEditDisplayName('block')} 
                          style={{display: isEditDisplayName === 'none' ? '' : 'none'}}
                        >
                          {displayName ? displayName : '...'}
                        </span>
                        <span className="editable-container editable-inline" style={{display: isEditDisplayName}}>
                          <form className="form-inline editableform">
                            <div className="control-group form-group">
                              <div>
                                <div className="editable-input">
                                  <input type="text" className="form-control input-sm" value={displayName} onChange={(event) => handelChange(event, 'displayName')} />
                                </div>
                                <div className="editable-buttons">
                                  <button type="button" className="btn btn-info editable-submit" onClick={() => saveData('displayName')}>
                                    <i className="ace-icon fa fa-check"></i>
                                  </button>
                                  <button type="button" className="btn editable-cancel" onClick={() => setIsEditDisplayName('none')}>
                                    <i className="ace-icon fa fa-times"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="editable-error-block help-block"></div>
                            </div>
                          </form>
                        </span>
											</div>
										</div>

										<div className="profile-info-row">
											<div className="profile-info-name"> Имя </div>

											<div className="profile-info-value">
												<span
                          className="editable editable-click"
                          id="firstName" 
                          onClick={() => setIsEditFirstName('block')} 
                          style={{display: isEditFirstName === 'none' ? '' : 'none'}}
                        >
                          {firstName ? firstName : '...'}
                        </span>
                        <span className="editable-container editable-inline" style={{display: isEditFirstName}}>
                          <form className="form-inline editableform">
                            <div className="control-group form-group">
                              <div>
                                <div className="editable-input">
                                  <input type="text" className="form-control input-sm" value={firstName} onChange={(event) => handelChange(event, 'firstName')} />
                                </div>
                                <div className="editable-buttons">
                                  <button type="button" className="btn btn-info editable-submit" onClick={() => saveData('firstName')}>
                                    <i className="ace-icon fa fa-check"></i>
                                  </button>
                                  <button type="button" className="btn editable-cancel" onClick={() => setIsEditFirstName('none')}>
                                    <i className="ace-icon fa fa-times"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="editable-error-block help-block"></div>
                            </div>
                          </form>
                        </span>
											</div>
										</div>

										<div className="profile-info-row">
											<div className="profile-info-name"> Фамилия </div>

											<div className="profile-info-value">
												<span
                          className="editable editable-click"
                          id="lastName" 
                          onClick={() => setIsEditLastName('block')} 
                          style={{display: isEditLastName === 'none' ? '' : 'none'}}
                        >
                          {lastName ? lastName : '...'}
                        </span>
                        <span className="editable-container editable-inline" style={{display: isEditLastName}}>
                          <form className="form-inline editableform">
                            <div className="control-group form-group">
                              <div>
                                <div className="editable-input">
                                  <input type="text" className="form-control input-sm" value={lastName} onChange={(event) => handelChange(event, 'lastName')} />
                                </div>
                                <div className="editable-buttons">
                                  <button type="button" className="btn btn-info editable-submit" onClick={() => saveData('lastName')}>
                                    <i className="ace-icon fa fa-check"></i>
                                  </button>
                                  <button type="button" className="btn editable-cancel" onClick={() => setIsEditLastName('none')}>
                                    <i className="ace-icon fa fa-times"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="editable-error-block help-block"></div>
                            </div>
                          </form>
                        </span>
											</div>
										</div>
										
										<div className="profile-info-row">
											<div className="profile-info-name"> E-mail </div>

											<div className="profile-info-value">
												<span
                          className="editable editable-click"
                          id="email" 
                          onClick={() => setIsEditEmail('block')} 
                          style={{display: isEditEmail === 'none' ? '' : 'none'}}
                        >
                          {email ? email : '...'}
                        </span>
												<span
													id="emailProvider"
													style={{display: isEditEmail === 'none' ? '' : 'none', fontSize: 11, color: '#494949'}}
												>
													({user.emailProvider})
												</span>
                        <span className="editable-container editable-inline" style={{display: isEditEmail}}>
                          <form className="form-inline editableform">
                            <div className="control-group form-group">
                              <div>
                                <div className="editable-input">
                                  <input type="text" className="form-control input-sm" value={email} onChange={(event) => handelChange(event, 'email')} />
                                </div>
                                <div className="editable-buttons">
                                  <button type="button" className="btn btn-info editable-submit" onClick={() => saveData('email')}>
                                    <i className="ace-icon fa fa-check"></i>
                                  </button>
                                  <button type="button" className="btn editable-cancel" onClick={() => setIsEditEmail('none')}>
                                    <i className="ace-icon fa fa-times"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="editable-error-block help-block"></div>
                            </div>
                          </form>
                        </span>
											</div>
										</div>

										<div className="profile-info-row">
											<div className="profile-info-name"> Участвует в рейтинге? </div>

											<div className="profile-info-value">
												<span
                          className="editable editable-click"
                          id="isShow" 
                          onClick={() => setIsEditIsShow('block')} 
                          style={{display: isEditIsShow === 'none' ? '' : 'none'}}
                        >
                          {isShow ? 'Да' : 'Нет'}
                        </span>
                        <span className="editable-container editable-inline" style={{display: isEditIsShow}}>
                          <form className="form-inline editableform">
                            <div className="control-group form-group">
                              <div>
                                <div className="editable-input">
																	<Select
																		items={[{alias: true, name: {ru: 'Да'}}, {alias: false, name: {ru: 'Нет'}}]}
																		placeholder="..." 
																		onChange={(event) => handelChange(event, 'isShow')} 
																		selectedValue={isShow}
																		index={'yes-no'}
																	/>
                                </div>
                                <div className="editable-buttons">
                                  <button type="button" className="btn btn-info editable-submit" onClick={() => saveData('isShow')}>
                                    <i className="ace-icon fa fa-check"></i>
                                  </button>
                                  <button type="button" className="btn editable-cancel" onClick={() => setIsEditIsShow('none')}>
                                    <i className="ace-icon fa fa-times"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="editable-error-block help-block"></div>
                            </div>
                          </form>
                        </span>
											</div>
										</div>

										<div className="profile-info-row">
											<div className="profile-info-name"> Дата регистрации </div>

											<div className="profile-info-value">
												<span id="dateCreated">
													{user.dateCreated}
												</span>
											</div>
										</div>

										<div className="profile-info-row">
											<div className="profile-info-name"> Дата обновления </div>

											<div className="profile-info-value">
												<span id="dateModified">
													{user.dateModified}
												</span>
											</div>
										</div>

										<div className="profile-info-row">
											<div className="profile-info-name"> Device Token </div>

											<div className="profile-info-value">
												<span id="deviceToken">
													{user.deviceToken}
												</span>
											</div>
										</div>
									</div>
							</div>
						</div>
					</div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
